import { render, staticRenderFns } from "./AdjustPricePanel.vue?vue&type=template&id=4b7ff98a&scoped=true"
import script from "./AdjustPricePanel.vue?vue&type=script&lang=js"
export * from "./AdjustPricePanel.vue?vue&type=script&lang=js"
import style0 from "./AdjustPricePanel.vue?vue&type=style&index=0&id=4b7ff98a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7ff98a",
  null
  
)

export default component.exports